import { useContext, useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { HomeContext } from '../utils/contexts/homeContext';
import { UserLoginAPIUrl, GetReligionAPIUrl, UserLoginSessionAPIUrl } from '../utils/extensions/functionEx';
import { useCookies } from 'react-cookie'
import { DocumentAPIUrl } from '../utils/extensions/functionEx';
import { ACCOUNT_ICON_DOC_ID } from '../startups/apiConfig';

export default function UserSignIn() {

  const { homeState, SetLoggedUser, ShowAPIError, OpenErrorAlert, SetReligions, SetAccountPersonIcon, SetHomeCCD } = useContext(HomeContext);

  //const { ccd } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [ccd, setCCD] = useState('');



  //console.log('UserSignIn ccd', ccd);

  // RTNFRTBEMzctQzdDODFBRkM4MkY4LUFNUlRBLUVEUEFMLTIwMjUwOTAx
  // ZTNlZTBkMzctYzdjODFhZmM4MmY4LWFtcnRhLWVkcGFsLTIwMjUwOTAx

  const [isLoading, setIsLoading] = useState(false);
  const [isInvalidUsername, setIsInvalidUsername] = useState(false);
  const [isInvalidPassword, setIsInvalidPassword] = useState(false);
  const [userName, setUserName] = useState('');
  const [userPwd, setUserPwd] = useState('');
  const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code', 'hplus_home_care_ccd_param']);

  useEffect(() => {
    let tempCCD = searchParams.get('ccd');
    if (tempCCD && tempCCD.trim().length > 0) {
      setCookie('hplus_home_care_ccd_param', tempCCD, { path: '/' });
      SetHomeCCD(tempCCD);
      //setCCD(tempCCD);
    } else {
      tempCCD = cookies.hplus_home_care_ccd_param ? cookies.hplus_home_care_ccd_param : '';
    }
    setCCD(tempCCD);
    console.log('UserSignIn useEffect ccd', tempCCD);

    if (!homeState.loggedUser.isUserLogged) {
      validateUserSessionCode(tempCCD);
    }
  }, []);

  async function loginSessionCode(tempCCD, userId, sessionCode) {
    try {
      setIsLoading(true);
      let tempReqJson = {
        session_code: sessionCode.trim(),
        user_id: userId,
        company_code: tempCCD.trim()
      };

      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Accept-Encoding", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(UserLoginSessionAPIUrl(), {
        method: "POST",
        headers: headers,
        body: JSON.stringify(tempReqJson)
      })
      if (response.status === 200) {
        const tempResJson = await response.json();
        console.log('loginSessionCode', tempResJson);

        SetLoggedUser(tempResJson.company_code, tempResJson.employee_id, tempResJson.employee_name, tempResJson.employee_photo_id, ccd, sessionCode.trim(), tempResJson.object_rights);

        await fetchReligions();
        await getAccountPersonIcon(tempResJson.company_code, tempResJson.employee_photo_id);
        setIsLoading(false);
        navigate("/reminder", { replace: false });
      } else {
        ShowAPIError(response);
        setIsLoading(false);
      }
    }
    catch (error) {
      OpenErrorAlert(error);
      setIsLoading(false);
    }
  }

  const handleUserLoginClick = async () => {
    try {
      await validateUserSessionCode();
      setIsInvalidUsername(false);
      setIsInvalidPassword(false);

      if (!ccd || ccd.trim().length === 0) {
        OpenErrorAlert('Company registration not found!');
        return;
      }

      if (!userName || userName.trim().length === 0) {
        setIsInvalidUsername(true);
        return;
      }

      if (!userPwd || userPwd.trim().length === 0) {
        setIsInvalidPassword(true);
        return;
      }
      setIsLoading(true);
      let tempReqJson = {
        username: userName.trim(),
        user_password: userPwd.trim(),
        company_code: ccd.trim()
      };

      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Accept-Encoding", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(UserLoginAPIUrl(), {
        method: "POST",
        headers: headers,
        body: JSON.stringify(tempReqJson)
      });
      if (response.status === 200) {
        const tempResJson = await response.json();

        console.log('tempResJson', tempResJson);
        console.log(new Date().toJSON());

        const cookieUserLogText = '!' + tempResJson.session_code + '!;!' + tempResJson.employee_id.toString() + '!;!' +
          tempResJson.company_code + '!;!' + new Date().toJSON() + '!;';

        setCookie('hplus_home_care_user_session_code', btoa(cookieUserLogText), { path: '/' });

        SetLoggedUser(tempResJson.company_code, tempResJson.employee_id, tempResJson.employee_name,
          tempResJson.employee_photo_id, ccd, tempResJson.session_code, tempResJson.object_rights);

        await fetchReligions();
        await getAccountPersonIcon(tempResJson.company_code, tempResJson.employee_photo_id);
        setIsLoading(false);
        navigate("/reminder", { replace: false });
      } else {
        ShowAPIError(response);
        setUserPwd('');
        setIsLoading(false);
      }
    }
    catch (error) {
      OpenErrorAlert(error);
      setUserPwd('');
      setIsLoading(false);
    }
  }

  const fetchReligions = async () => {
    try {
      const response = await fetch(GetReligionAPIUrl())
      if (response.status === 200) {
        SetReligions(await response.json());
      } else {
        ShowAPIError(response)
      }
    }
    catch (error) {
      OpenErrorAlert(error)
    }
  }

  async function getAccountPersonIcon(companyCode, photoId) {
    try {
      const headers = new Headers();
      headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
      const response = await fetch(DocumentAPIUrl(companyCode, photoId > 0 ? photoId : ACCOUNT_ICON_DOC_ID), { headers });
      if (response.status === 200) {
        console.log('getAccountPersonIcon response');
        const docTempJson = await response.json();

        if (docTempJson && docTempJson.uploaded_file) {
          SetAccountPersonIcon(docTempJson.uploaded_file);
        }
      }
    }
    catch (error) {
      console.log('getAccountPersonIcon error', error);
      OpenErrorAlert(error);
    }
  }

  const validateUserSessionCode = async (tempCCD) => {
    let tempSessionCode = '';
    let tempUserId = 0;
    const cookieCode = cookies.hplus_home_care_user_session_code;

    if (cookieCode && cookieCode.length > 0) {
      const textParts = atob(cookieCode).split('!;');
      console.log('parts', textParts);

      if (textParts.length >= 2) {
        tempSessionCode = textParts[0].replaceAll('!', '');
        tempUserId = textParts[1].replaceAll('!', '');
      }
    }
    if (tempSessionCode && tempUserId && tempSessionCode.trim().length > 0 && tempUserId.trim().length > 0) {
      await loginSessionCode(tempCCD, parseInt(tempUserId), tempSessionCode);
    }
  }

  return (
    <Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
        }}
      >
        <Grid container spacing={0}>
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>

            <Box
              sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Sign in
              </Typography>

              <Box noValidate sx={{ mt: 1 }}>

                <TextField error={isInvalidUsername} helperText={isInvalidUsername ? "Enter valid username." : ""}
                  margin="normal"
                  required
                  fullWidth
                  label="Username"
                  autoComplete="hc-username"
                  autoFocus
                  value={userName}
                  onChange={(event) => {
                    setUserName(event.target.value);
                  }}
                  slotProps={{
                    input: {
                      readOnly: isLoading,
                    },
                  }}
                />

                <TextField error={isInvalidPassword} helperText={isInvalidPassword ? "Enter valid password." : ""}
                  margin="normal"
                  required
                  fullWidth
                  label="Password"
                  type="password"
                  autoComplete="hc-current-password"
                  value={userPwd}
                  onChange={(event) => {
                    setUserPwd(event.target.value);
                  }}
                  slotProps={{
                    input: {
                      readOnly: isLoading,
                    },
                  }}
                />

                <Button onClick={handleUserLoginClick}
                  fullWidth loading={isLoading} loadingPosition="end"
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Sign In
                </Button>

              </Box>
            </Box>

          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}